import React, { useState } from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import RecommendationPanel from "./RecommendationPanel";
import Reveal from "@/components/marketing/Reveal";

const GOALS = [
  { id: "funding", label: "Announce funding, milestones, or company news", primary: "newswire", combo: "placements", why: "Broad, same-day pickup across business and financial media, paired with named tier-1 outlets for the people who actually sign cheques." },
  { id: "seo", label: "Build SEO and backlinks", primary: "placements", combo: null, why: "Dofollow placements on real, established domains. This is the channel built specifically for search performance." },
  { id: "credibility", label: "Add credibility before a raise", primary: "placements", combo: "newswire", why: "Publication in named outlets your investors already read, amplified by broad syndication so the story travels." },
  { id: "earned", label: "Earn genuine journalist coverage", primary: "outreach", combo: null, why: "Targeted, direct outreach to verified journalists by beat and geography. Coverage pitched on merit, not bought." },
  { id: "launch", label: "Launch a product", primary: "outreach", combo: "newswire", why: "Earned stories from journalists who cover your space, with newswire syndication carrying reach on launch day." },
  { id: "market", label: "Enter a new market or region", primary: "newswire", combo: "placements", why: "Regional newswire syndication plus named local publications in the exact market you are moving into." },
  { id: "thought", label: "Build thought leadership for a founder or executive", primary: "outreach", combo: "placements", why: "Earned commentary and expert positioning with journalists who cover your space, backed by placements in named outlets that anchor the profile." },
  { id: "crypto", label: "Announce a token or crypto project", primary: "newswire", combo: "placements", why: "Syndication across dedicated crypto newswires and digital-asset media, paired with placements in named crypto and finance outlets." },
  { id: "event", label: "Promote an event or timed announcement", primary: "newswire", combo: null, why: "Same-day syndication built for dates that don't move — conferences, embargo lifts, and launch-day announcements." },
  { id: "crisis", label: "Respond to a crisis or protect your reputation", primary: null, combo: null, why: "Crisis situations need judgement before distribution — the wrong announcement, amplified, makes things worse. Talk to our team first and we'll help you work out whether, when, and where to distribute." },
];

export default function GoalRouter() {
  const [selected, setSelected] = useState(null);
  const goal = GOALS.find((g) => g.id === selected);

  return (
    <section id="find-your-goal" className="bg-canvas py-11 lg:py-[72px] scroll-mt-24">
      <Container>
        <Reveal>
        <SectionHeading
          tag="WHAT'S YOUR GOAL"
          title="What are you trying to do?"
          subtitle="Pick the goal closest to yours. We'll recommend the channel, or the combination, built for it."
        />
        </Reveal>

        <div className="glass-card p-5 sm:p-6 lg:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {GOALS.map((g) => (
              <button
                key={g.id}
                type="button"
                onClick={() => setSelected(g.id)}
                className={`cursor-pointer text-left px-5 py-4 rounded-[14px] border text-[15px] leading-snug transition-all duration-150 ease-out ${
                  g.id === "crisis" ? "lg:col-start-2 " : ""
                }${
                  selected === g.id
                    ? "bg-brand-gradient border-transparent text-white font-semibold shadow-[0_8px_20px_rgba(124,58,237,0.25)]"
                    : "bg-white/60 border-[#d8d5e2] text-[#3a3646] hover:bg-white/80 hover:border-cobalt hover:text-[#14121c] hover:-translate-y-px hover:shadow-sm"
                }`}
              >
                {g.label}
              </button>
            ))}
          </div>

          {goal && (
            <div className="mt-6 pt-6 border-t border-[#ececf2]">
              <RecommendationPanel goal={goal} />
            </div>
          )}
        </div>
      </Container>
    </section>
  );
}